import { render, staticRenderFns } from "./BaseForm.vue?vue&type=template&id=02d6ae20&scoped=true&"
import script from "./BaseForm.vue?vue&type=script&lang=js&"
export * from "./BaseForm.vue?vue&type=script&lang=js&"
import style0 from "./BaseForm.vue?vue&type=style&index=0&id=02d6ae20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d6ae20",
  null
  
)

export default component.exports